<script>
import Config from '@/config';
import Size from '@/mixins/size';
import {pageIsFinish} from '@/libs/util';
import {getCouponList, couponExchange} from '@/api';
import {Image, Field, Button, List, PullRefresh, Toast} from 'vant';

export default {
  mixins: [
    Size
  ],
  components: {
    [List.name]: List,
    [Image.name]: Image,
    [Field.name]: Field,
    [Button.name]: Button,
    [PullRefresh.name]: PullRefresh
  },
  data() {
    return {
      page: 1,
      coupons: [],

      outSn: null,
      kwh: '',

      loading: false,
      finished: false,
      refreshing: false,
      listLoading: false
    }
  },
  computed: {
    outSnError() {
      return Boolean(this.outSn && this.outSn.trim().length < 6);
    },
    kwhSnError() {
      return Boolean(this.kwh && value.this.kwh().length < 3);
    },
    disabled() {
      return !this.outSn || this.outSnError || !this.kwh || this.kwhSnError;
    }
  },
  mounted() {
    window.document.title = '速电通-我的卡券';
  },
  methods: {
    refresh() {
      this.page = 1;
      this.finished = false;
      this.loadData();
    },
    loadData() {
      if (this.refreshing) {
        this.coupons = [];
        this.refreshing = false;
      }

      this.listLoading = true;
      getCouponList('', this.page, Config.pageSize).then(response => {
        if (response.data.code === Config.successCode) {
          this.coupons = this.page === 1 ? response.data.body.data : this.coupons.concat(response.data.body.data);
          this.finished = pageIsFinish(response.data.body);
          this.page = response.data.body.page + 1;
        }
      }).finally(() => this.listLoading = false).catch(() => this.finished = true);
    },
    exchange() {
      if (this.disabled) {
        return;
      }

      this.loading = true;
      couponExchange(this.outSn, this.kwh).then(response => {
        if (response.data.code === Config.successCode) {
          this.refresh();
          Toast.success('获取成功');
        }
      }).finally(() => {
        this.loading = false;
      });
    },
    toCouponUse(id) {
      this.$router.push({name: 'couponUse', params: {id}});
    }
  }
}
</script>

<template>
  <van-pull-refresh v-model="refreshing" @refresh="refresh" id="coupon">
    <div class="form">
      <div class="fields">
        <van-field v-model="outSn" :error="outSnError" clearable label="订单号" placeholder="请至少输入第三方充电订单号后六位" titleWidth="60px"/>
        <van-field v-model="kwh" :error="kwhSnError" clearable type="digit" label="充电量" placeholder="请输入第三方充电订单充电电量" titleWidth="60px"/>
      </div>
      <div class="submit-button">
        <van-button :disabled="disabled" :loading="loading" @click="exchange" v-prevent-re-click round block color="#009251" loading-text="获取中...">获取兑换券</van-button>
      </div>
    </div>
    <div class="list">
      <div class="title">
        <div>可使用的卡券：</div>
        <div class="num">{{ total }}</div>
        <div>张</div>
      </div>
      <van-list v-model="listLoading" :finished="finished" :finished-text="coupons.length === 0 ? '' : '没有更多了'" @load="loadData" class="coupons">
        <div class="item" v-for="(item, index) in coupons" :key="index">
          <div class="top" @click="toCouponUse(item.id)">
            <van-image radius="4" width="83" height="60" lazy-load :src="item.cover"/>
            <div class="right">
              <div class="row">
                <div class="type">{{ item.type === 1 ? '充值券' : '兑换券' }}</div>
                <div class="label">{{ item.title }}</div>
              </div>
              <div v-if="item.type === 1" class="row">
                <div>金额：</div>
                <div class="value">{{ item.amount }}元</div>
              </div>
              <div v-if="item.type === 2" class="row">
                <div>券码：</div>
                <div class="value">{{ item.code }}</div>
              </div>
              <div class="row">
                <div>有效期：</div>
                <div class="space">{{ item.validDate }}</div>
              </div>
            </div>
          </div>
          <div class="v-split">
            <div class="left sdt-half-circle"></div>
            <div class="line"></div>
            <div class="right sdt-half-circle"></div>
          </div>
          <div class="bottom">使用说明：{{ item.description }}</div>
        </div>
      </van-list>
      <div v-if="coupons.length === 0" :style="{height: (height - 188) + 'px'}" class="no-data">
        <div class="content">
          <img src="../assets/images/no-data.png"/>
        </div>
      </div>
    </div>
  </van-pull-refresh>
</template>

<style scoped>
#coupon {
  background-color: #F6F9F8;
}

#coupon .form {
  background-color: white;
}

#coupon .form .submit-button {
  padding: 12px;
}

#coupon .form .submit-button .van-button {
  box-shadow: 0 3px 6px 1px rgba(0, 146, 81, 0.41);
}

#coupon .list {
  padding: 12px;
}

#coupon .list .title {
  display: flex;
  align-items: center;

  color: #333333;
  font-size: 14px;
  font-weight: 500;
}

#coupon .list .title .num {
  color: #009251;
  font-size: 16px;
  font-weight: bold;
  margin-right: 5px;
}

#coupon .list .coupons {
  border-radius: 8px;
}

#coupon .list .coupons .item {
  margin-top: 12px;
  border-radius: 8px;
}

#coupon .list .coupons .item .top {
  display: flex;
  align-items: center;
  background-color: white;
  border-radius: 8px 8px 0 0;
  padding: 12px 12px 4px 12px;
}

#coupon .list .coupons .item .top .right {
  flex: 1;
  margin-left: 12px;
}

#coupon .list .coupons .item .top .right .row {
  display: flex;
  align-items: center;

  color: #999999;
  font-size: 12px;
  font-weight: 500;
}

#coupon .list .coupons .item .top .right .row + .row {
  margin-top: 8px;
}

#coupon .list .coupons .item .top .right .row .type {
  width: 48px;
  padding: 4px;
  color: white;
  font-size: 12px;
  text-align: center;
  border-radius: 16px;
  background-color: #009251;
}

#coupon .list .coupons .item .top .right .row .label {
  color: #333333;
  font-size: 14px;
  font-weight: bold;
  margin-left: 4px;
}

#coupon .list .coupons .item .top .right .row .value {
  color: #009251;
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 2px;
}

#coupon .list .coupons .item .top .right .row .space {
  letter-spacing: 1px;
}

#coupon .list .coupons .item .v-split {
  display: flex;
  align-items: center;
  background-color: white;
}

#coupon .list .coupons .item .v-split .left {
  transform: rotate(180deg);
}

#coupon .list .coupons .item .v-split .line {
  flex: 1;
  border-top: 1px solid #EEEEEE;
}

#coupon .list .coupons .item .v-split .left,
#coupon .list .coupons .item .v-split .right {
  color: #F8F8F6;
  font-size: 12px;
  background-color: white;
}

#coupon .list .coupons .item .bottom {
  color: #999999;
  font-size: 12px;
  font-weight: 500;

  background-color: white;
  border-radius: 0 0 8px 8px;
  padding: 6px 12px 12px 12px;
}
</style>
